import { CensoredSystem } from 'app/shared/collections/censored_system';
import { cloneDeep } from 'lodash';
import { IntegrationResource } from '../resources';
import { ImsObject } from './ims_object';

export const IMS_TYPE__INTEGRATION = 'integration';

export interface IntegrationConfig {
    always_poll?: boolean;
}

interface IIntegrationResource {
    id: number | null;
    key: string | null;
    active: boolean | null;
    system_id: number | null;
    asset_id: number | null;
    ip_device_id: number | null;
    config: IntegrationConfig | null;
}

export class Integration extends ImsObject {
    system: CensoredSystem;

    constructor(resource: IIntegrationResource = new IntegrationResource()) {
        super(IMS_TYPE__INTEGRATION, resource);
    }

    public clone(): Integration {
        return new Integration(cloneDeep(this.resource));
    }

    get config(): IntegrationConfig {
        return this.resource.config;
    }

    set config(value: IntegrationConfig) {
        this.resource.config = value;
    }

    get key(): string {
        return this.resource.key;
    }

    set key(value: string) {
        this.resource.key = value;
    }

    get systemId(): number {
        return this.resource.system_id;
    }

    set systemId(value: number) {
        this.resource.system_id = value;
    }

    get systemName(): string {
        return this.system ? this.system.name : undefined;
    }

    get active(): boolean {
        return this.resource.active;
    }

    set active(value: boolean) {
        this.resource.active = value;
    }

    get assetId(): number {
        return this.resource.asset_id;
    }

    set assetId(value: number) {
        this.resource.asset_id = value;
    }

    get ipDeviceId(): number {
        return this.resource.ip_device_id;
    }

    set ipDeviceId(value: number) {
        this.resource.ip_device_id = value;
    }

    get isDeleted(): boolean {
        return this.resource.is_deleted;
    }

    set isDeleted(value: boolean) {
        this.resource.is_deleted = value;
    }
}
